export enum FeatureToggle {
  connectOrders = 'rt_connect_orders',
  rescheduleAndCancelConnectOrder = 'rt_reschedule_and_cancel_connect_order',
  operationalDashboard = 'rt_connect_operational_dashboard',
  createConnectOrder = 'rt_create_connect_order',
  orderCancellationReason = 'rt_connect_order_cancellation_reason',
  LMDDashboardEnhancements = 'rt_esi_lmd_dashboard_enhancements',
}
